import { Box } from '@bfa/common-ui';
import { externalRedirect } from '@bfa/nextjs-common/utils';
import React from 'react';

import { ABSOLUTE_URLS } from '../../../constants';
import { Callback } from '../../../utils/types';
import Actions from './Actions';
import Body from './Body';
import { ContentContainer, PageContainer } from './Container';
import HeroImage from './HeroImage';
import Title from './Title';

type Props = {
  image: { src: string; alt: string };
  title: string;
  body?: string;
  withSeparator?: boolean;
  confirmUrl: string;
  confirmLabel: string;
  dismissLabel?: string | null;
  dismissUrl?: string;
  primaryActionOnClick: Callback;
  secondaryActionOnClick: Callback;
};

const Popup = ({
  image,
  title,
  body,
  withSeparator,
  confirmLabel,
  confirmUrl,
  dismissLabel,
  dismissUrl,
  primaryActionOnClick,
  secondaryActionOnClick,
}: Props) => {
  return (
    <PageContainer>
      <HeroImage image={image} />
      <ContentContainer>
        <Title>{title}</Title>
        {withSeparator ? (
          <Box
            width="10rem"
            backgroundColor="#ED4880"
            height="0.4rem"
            margin="1rem auto"
            data-testid="popup-separator"
          />
        ) : null}
        <Body>{body}</Body>
        {confirmLabel && dismissLabel ? (
          <Actions
            primaryOnClick={() => {
              primaryActionOnClick();
              window.location.href = confirmUrl;
            }}
            secondaryOnClick={() => {
              secondaryActionOnClick();
              externalRedirect(dismissUrl || ABSOLUTE_URLS.GLAM_BAG);
            }}
            primaryLabel={confirmLabel}
            secondaryLabel={dismissLabel}
          />
        ) : null}
      </ContentContainer>
    </PageContainer>
  );
};

export default Popup;
